/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FunctionComponent, ReactNode } from "react";
import { IContentLoaderProps } from "react-content-loader";
import { Loader, LoaderProps } from "@nordcloud/gnui";

type LoaderWrapProps = IContentLoaderProps &
  LoaderProps & {
    loading: boolean;
    children: ReactNode;
    Component?: FunctionComponent<LoaderProps>;
  };

export function LoaderWrap({ loading, children, Component = Loader, ...props }: LoaderWrapProps) {
  return loading ? <Component {...props} /> : <>{children}</>;
}
